import { EMPTY_OBJECT } from "./constants.js";

/**
 * Maps an open-change `reason` string to the corresponding native event type.
 */

/**
 * Details of custom change events emitted by Base UI components.
 */

/**
 * Details of custom generic events emitted by Base UI components.
 */

/**
 * Creates a Base UI event details object with the given reason and utilities
 * for preventing Base UI's internal event handling.
 */
export function createChangeEventDetails(reason, event, customProperties) {
  let canceled = false;
  let allowPropagation = false;
  const custom = customProperties ?? EMPTY_OBJECT;
  return {
    reason,
    event: event ?? new Event('base-ui'),
    cancel() {
      canceled = true;
    },
    allowPropagation() {
      allowPropagation = true;
    },
    get isCanceled() {
      return canceled;
    },
    get isPropagationAllowed() {
      return allowPropagation;
    },
    ...custom
  };
}
export function createGenericEventDetails(reason, event, custom) {
  const customProperties = custom ?? EMPTY_OBJECT;
  return {
    reason,
    event: event ?? new Event('base-ui'),
    ...customProperties
  };
}